import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	sizeProyectAll: [],
	sizeProyect: [],
	averageSizeProjects: { averages: [], totals: [] },
	filtersTable: {
		sizeProjects: [],
		yearsSelect: [],
	},
	loadings: {
		table: false,
	},
	selectDate: "",
};

export const isAnalitySlice = createSlice({
	name: "general",
	// estado inicial definido en la parte superior line:3
	initialState,
	// todas las acciones que puden modificar el store
	reducers: {
		setLoading: (state, { payload }) => {
			state.loadings = payload;
		},
		setSizeProyect: (state, { payload }) => {
			state.sizeProyect = payload;
		},
		setSizeProyectAll: (state, { payload }) => {
			state.sizeProyectAll = payload;
		},
		setFiltersTable: (state, { payload }) => {
			state.filtersTable = payload;
		},
		setAverageSizeProjects: (state, { payload }) => {
			state.averageSizeProjects = payload;
		},
		setSelectDate: (state, { payload }) => {
			state.selectDate = payload;
		},
	},
});

export const { setLoading, setSizeProyect, setSizeProyectAll, setFiltersTable, setAverageSizeProjects, setSelectDate } = isAnalitySlice.actions;
